var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconIncBonus(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.75 2.75H14.75C13.9544 2.75 13.1913 3.06607 12.6287 3.62868C12.0661 4.19129 11.75 4.95435 11.75 5.75C11.75 6.54565 12.0661 7.30871 12.6287 7.87132C13.1913 8.43393 13.9544 8.75 14.75 8.75H15.75C16.5456 8.75 17.3087 9.06607 17.8713 9.62868C18.4339 10.1913 18.75 10.9544 18.75 11.75C18.75 12.5456 18.4339 13.3087 17.8713 13.8713C17.3087 14.4339 16.5456 14.75 15.75 14.75H11.75M14.75 16.75V14.75M15.75 2.75V0.75M4.75 8.75C5.54565 8.75 6.30871 9.06607 6.87132 9.62868C7.43393 10.1913 7.75 10.9544 7.75 11.75C7.75 12.5456 7.43393 13.3087 6.87132 13.8713C6.30871 14.4339 5.54565 14.75 4.75 14.75H0.75V2.75H4.75C5.54565 2.75 6.30871 3.06607 6.87132 3.62868C7.43393 4.19129 7.75 4.95435 7.75 5.75C7.75 6.54565 7.43393 7.30871 6.87132 7.87132C6.30871 8.43393 5.54565 8.75 4.75 8.75ZM4.75 8.75H0.75",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconIncBonus);
export default __webpack_public_path__ + "static/media/icon_inc_bonus.e2622117aa86eadfcdaf81812b8f50be.svg";
export { ForwardRef as ReactComponent };